module.exports = __webpack_public_path__ + "img/SAP_8649_l.ab398f10.jpg";